/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const getPaycardStatusByIdIdRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');


export const GetPaycardStatusById = zod.object({
  "id": zod.union([zod.number(),zod.string().regex(getPaycardStatusByIdIdRegExpTwo)]).optional()
});

export type GetPaycardStatusById = zod.input<typeof GetPaycardStatusById>;
export type GetPaycardStatusByIdOutput = zod.output<typeof GetPaycardStatusById>;
